import { Age } from "../../shared";
import { FragranceType } from "./fregrance";
import { FoundationTypeType } from "./fundation-type";
import { MarriedType } from "./married";
import { SensitiveSkinType } from "./sensitive-skin";
import { StrategyGroupCategory } from "./category";
import { SkinAttributeType } from "./skin-attribute";
import { ChannelType } from "./channel";
import { ChildrenType } from "./children";
import { OccupationType } from "./occupation";
import { CategoryOrAndType } from "./category-and-or";
import { FacewashFunctionType } from "./face-function/types";
import { SkinProblemFrequencyType } from "./skin-problem-frequency/types";
import { SensitiveSkinFrequencyRankType } from "./sensitive-skin-frequency-rank";
import { NonPurchaseCategoryConfig } from "./none-purchase-category";
import { LipstickTypeType } from "./lipstick-type";
import { EyeshaowTypeType } from "./eyeshaow-type";
import { Gypsy } from "./gipsy";
import { AestheticMedicineExperienceType } from "./aesthetic-medicine-experience";
import { BeautySupplementCategoryType } from "./beauty-supplement-category";
import { OtherConcernsType } from "./other-concerns";
import { AestheticMedicineExperienceMTType } from "./aesthetic-medicine-experience-mt";

export type StrategyGroup = {
	age: Age;
	married: MarriedType[]; //未既婚
	children: ChildrenType[]; //子ども有無
	occupation: OccupationType[]; //職業
	skinAttribute: SkinAttributeType[]; //肌悩み
	sensitiveSkin: SensitiveSkinType[]; //敏感肌

	categoryOrAnd: CategoryOrAndType;
	category: StrategyGroupCategory[];
	channel: ChannelType[];
	fragrance?: FragranceType[];
	foundationType?: FoundationTypeType[];
	facewashFunction?: FacewashFunctionType;

	/** 過去一年非購入カテゴリ設定 */
	nonPurchaseCategoryConfig?: NonPurchaseCategoryConfig;

	sensitiveSkinFrequency?: SensitiveSkinFrequencyRankType[]; // 敏感肌頻度（敏感肌/ときどき敏感肌のみ）
	skinProblemFrequency?: SkinProblemFrequencyType[]; // 肌トラブル

	/** 口紅・リップグロス使用カテゴリ */
	lipstickType?: LipstickTypeType[];
	/** アイシャドー使用カテゴリ */
	eyeshadowType?: EyeshaowTypeType[];
	/** ジプシー */
	gypsy?: Gypsy;
	/** @deprecated 美容医療利用経験: 20261102 -- v3.1.0から廃止 */
	aestheticMedicineExperience?: AestheticMedicineExperienceType[];

	/** 美容医療利用経験: しみ改善目的の美容医療（※シミ取りレーザー 等）*/
	aestheticMedicineExperienceSpot?: AestheticMedicineExperienceMTType[];
	/** 美容医療利用経験: 肌の明るさ/くすみ/色むら/肝斑の改善目的の美容医療（※レーザートーニング、光治療（フォトフェイシャルなど）、ピーリング、注入 等）*/
	aestheticMedicineExperienceTone?: AestheticMedicineExperienceMTType[];
	/** 美容医療利用経験: しわ・たるみ改善などエイジングケア目的の美容医療（※ハイフ、糸リフト、クマ取り、ボトックス注射、ヒアルロン酸注入 等）*/
	aestheticMedicineExperienceAging?: AestheticMedicineExperienceMTType[];

	// 20261030
	/** その他のお悩み */
	otherConcerns?: OtherConcernsType[];
	/** 美容サプリメント・美容ドリンク使用カテゴリ */
	beautySupplementCategory?: BeautySupplementCategoryType[];
};
